<template>
    <div>
        <div class="bg-light shadow-md rounded p-4">
            <!-- Detalles de la reserva -->
            <nav class="navbar navbar-light bg-light rounded justify-content-between">
                <div class="row">
                    <div class="col-auto">
                        <span class="h6">Reserva</span><br>
                        <span class="h2 text-blue"><b>{{ reserva.id }}</b></span>
                    </div>
                    <div class="col-auto">
                        <div class="h4 text-primary p-2">{{ RES.std }}</div>
                    </div>
                    <div class="col-auto">
                        <div class="btn-group">
                            <b-btn variant="outline-success" size="sm"
                                v-show="reserva.std<4 && reserva.pte>'0'" @click="reserva_pdf">
                                <i class="mr-1 fa fa-print"></i>RESERVA
                            </b-btn>
                            <b-btn class="ml-2" variant="outline-success" size="sm"
                                v-show="reserva.std<4 && reserva.pte>'0'" @click="pagoTarjeta">
                                <i class="mr-1 fa fa-credit-card"></i>PAGO TARJETA
                            </b-btn>
                            <b-btn class="ml-2"  variant="outline-success" size="sm"
                                v-show="reserva.std==3" @click="bonos_pdf">
                                <i class="mr-1 fa fa-print"></i>BONOS
                            </b-btn>
                            <b-btn class="rl-action mx-sm-2" variant="outline-danger" size="sm"
                                v-show="reserva.std<4" @click="anular">
                                <i class="mr-1 fa fa-trash"></i>ANULAR
                            </b-btn>
                        </div>
                    </div>
                </div>
            </nav>
            <hr>
            <!-- Información del Hotel -->
            <div class="row">
                <div class="col-sm-12">
                    <div class="row">
                        <div class="col-3">
                            <!-- <strong>{{ reserva.hotel }}</strong>
                            <address>
                                <p><img :src="require('@/assets/css/img/map-marker-icon.svg')" />
                                    {{ reserva.pobla}}
                                </p>
                            </address> -->
                            <img class="img-fluid rounded" :src="imgUrl()" width="80%">
                        </div>
                        <div class="col-9">

                            <div class="row">
                                 <div class="col-7">
                                    <strong>{{ reserva.hotel }}</strong>
                                    <p>
                                        <img :src="require('@/assets/css/img/map-marker-icon.svg')" />
                                        {{ reserva.pobla}}
                                    </p>
                                </div>
                                <div class="col-4">
                                    <span class="small">Emitida</span>
                                    <p><b>{{ reserva.fh }}</b></p>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-3">
                                    <span class="small">Fecha Entrada</span>
                                    <p><b>{{ reserva.fhe }}</b></p>
                                </div>
                                <div class="col-4">
                                    <span class="small">Fecha Salida</span>
                                    <p><b>{{ reserva.fhs }}</b></p>
                                </div>
                                <div class="col-3"><span class="small">Noches</span>
                                    <p><b>{{ reserva.noc }}</b></p>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-3"><span class="small">Habitaciones</span>
                                    <p><strong>1 {{ reserva.tph }}</strong></p>
                                </div>
                                <div class="col-6"><span class="small">Personas</span>
                                    <p><strong>{{ RES.pax }}</strong></p>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <hr>
            <!-- Información de huéspedes -->
            <div class="row">
                <div class="col-sm-5"><i class="fas fa-users text-secondary"></i> <span class="ml-1">A
                        nombre de:</span> <strong>{{ reserva.n1 }}</strong> </div>
                <div class="col-sm-7"> <span class="small">Otros huéspedes (Total pax: {{ reserva.pax }})</span></div>
            </div>
            <div class="row">
                <div class="col-sm-5">
                    <p class="mt-2 mb-0"><span class="d-table-cell font-italic">Teléfono/s :</span><span
                            class="d-table-cell  font-weight-bold pl-2">{{ reserva.tfn1 }} {{ reserva.tfn2 }}</span>
                    </p>
                    <p class="mt-2 mb-0"><span class="d-table-cell font-italic">Email:</span><span
                            class="d-table-cell  font-weight-bold pl-2">{{ reserva.ema }}</span>
                    </p>

                </div>
                <div class="col-sm-6">
                    <p class="mb-0">{{ reserva.n2 }}</p>
                    <p class="mb-0">{{ reserva.n3 }}</p>
                    <p class="mb-0">{{ reserva.n4 }}</p>
                </div>
            </div><!-- Fin información de huéspedes -->

            <hr>

            <!-- Información de Servicios -->
            <div class="row">
                <div class="col-sm-5"><i class="fas fa-utensils text-secondary"></i> <span
                        class="ml-1">Servicios: </span><strong>{{ RES.reg }}</strong>
                    <p class="mt-2 mb-0">
                        <span class="d-table-cell font-italic">Primer servicio hotel:</span>
                        <span class="d-table-cell  font-weight-bold pl-2">{{ reserva.Cent }}</span>
                    </p>
                    <p class="mt-1 mb-0">
                        <span class="d-table-cell  font-italic">Último servicio hotel:</span>
                        <span class="d-table-cell font-italic font-weight-bold pl-2">{{ reserva.Csal }}</span>
                    </p>
                </div>
                <div class="col-sm-7"> <span class="small">Observaciones</span>
                    <p class="mb-0" v-show="reserva.desIN>''">
                        <span class="d-table-cell font-italic">Incluido:</span>
                        <span class="d-table-cell font-weight-bold pl-2">{{ reserva.desIN }}</span>
                    </p>
                    <p class="mb-0" v-show="reserva.desNO>''">
                        <span class="d-table-cell font-italic">No Incluido:</span>
                        <span class="d-table-cell font-weight-bold pl-2">{{ reserva.desNO }}</span>
                    </p>
                    <!-- <p class="mt-1 mb-0">
                        <span class="d-table-cell  font-italic">No incluido:</span>
                        <span class="d-table-cell font-weight-bold pl-2">Animación en el hotel</span>
                    </p> -->
                </div>
            </div> <!-- Fin información de servicios -->

            <hr>

            <!-- Información de Transporte -->
            <div class="row">
                <div class="col-sm-5"><i class="fas fa-bus text-secondary"></i> <span
                        class="ml-1">Transporte: </span><p><strong>{{reserva.sal }}</strong></p>
                </div>
                <div class="col-sm-7"><span class="small">Salida (si es con Bus)</span>
                    <!-- <p class="mb-0">
                        <span class="d-table-cell font-italic">Estación de autobuses de Alicante</span>
                    </p> -->
                </div>
            </div>
            <!-- Fin información de Precios -->

            <hr>

            <!-- Información de Precios -->
            <div class="row">
                <div class="col-sm-5">
                    <i class="fas fa-credit-card text-secondary"></i>
                    <span class="ml-1">Importe reserva: </span><strong>{{ reserva.tot }} €</strong>
                    <p class="mb-0 small"><span class="d-table-cell font-italic">Precio x Persona:</span><span class="d-table-cell  font-weight-bold pl-1">{{ reserva.pre }} €</span></p>
                    <!-- <p class="mb-0"><span class="d-table-cell font-italic">Paquete turístico:</span><span class="d-table-cell  font-weight-bold pl-2">290 €</span></p> -->
                </div>
                <div class="col-sm-7">
                    <span class="small">Extras</span>
                    <p class="mb-0">
                        <span class="d-table-cell font-italic">Seguro de Anulación</span>
                        <span class="d-table-cell  font-weight-bold pl-2"> 5,5 €</span>
                    </p>
                    <!-- <p class="mt-1 mb-0"><span class="d-table-cell  font-italic">Seguro Asistencia
                            Plus:</span><span class="d-table-cell font-weight-bold pl-2">27 € </span>
                    </p> -->
                </div>
            </div>
            <!-- Fin información de Precios -->

            <hr>

        </div>


    </div>
</template>

<script>

import { mapState, mapMutations, mapActions } from 'vuex';

export default {
    name: 'reserva',
    components: {
        //publicidad,
    },
    data() {
        return {
            message: 'Error',
        };
    },
    computed: {
        ...mapState(['G','auth','reserva','errores']),

        cta() {
            return this.auth.user;
        },
        admon() {
            return (this.cta.dep=='ADMON');
        },
        RES() {
            var aStd=['','PETICIÓN','CONFIRMADA','FACTURADA','ANULADA','CANCELADA'];
            var aReg=['','Alojamiento','Alojamiento y Desayuno','Media Pensión','Pensión Completa'];

            let std=aStd[this.reserva.std];
            let reg=aReg[this.reserva.reg];
            let pax=this.personas(this.reserva.tpp);
            let pte=this.$util.SN(this.reserva.pte);

            return { std, reg, pax, pte}
        },


    },
    methods: {
        ...mapMutations(['loading','alerta','modal']),
        ...mapActions(['exec']),

        //BANCO - TARJETA
        async pagoTarjeta() {
            //alert(this.RES.pte);
            let msg="Estas Seguro PAGO TARJETA ? <br>* Reserva <b>"+this.reserva.id +"</b><br>* Importe: <b>" + this.reserva.pte+"<b>";
            let r=await this.$root.$msgConf(msg,'RESERVAS');
            if (r) this.pagoBanco();
        },
        pagoBanco() {
            let url=this.G.url_tpv;
            let arg=new Date().getTime()+'|5.'+this.reserva.id+'|'+this.RES.pte;

            window.open(url+'?w='+arg,'_blank');
        },

        //RESERVA
        reserva_pdf0() {
            let url="https://iberopa.com/abks/adm.agencias/emisionReserva.EV.php?w=" + new Date().getTime() + "|" + this.reserva.id;
             window.open(url, '_blank');
        },
        async reserva_pdf() {
            //alert('Reserva');
            let r=await this.exec({ api:'reserva_pdf',
                arg: { sid: this.auth.token, id:this.reserva.id },
            });
            if (r.error) {
                this.modal({tit:"Reserva", msg:r.datos});
            } else {
                window.open(this.G.url_tmp+r.datos);
            }
        },
        //BONOS
        async bonos_pdf() {
            let r=await this.exec({ api:'bonos_pdf',
                arg: { sid: this.auth.token, id:this.reserva.id },
            });
            if (r.error) {
                this.modal({tit:"Bonos", msg:r.datos});
            } else {
                window.open(this.G.url_tmp+r.datos);
            }
        },
        //ANULAR
        async anular() {
            //alert('Anular');
            let msg="Estas Seguro ANULAR Reserva Nº "+this.reserva.id +" ?";
            let r=await this.$root.$msgConf(msg,'RESERVAS');
            if (!r) return;
            //anulamos reserva
            let x=await this.exec({ api:'anular',
                arg: { sid: this.auth.token, id:this.reserva.id },
            });
            msg=(!x.error ? "Reserva Nº"+x.datos+" ha sido Anulada ..." : x.datos);
            this.modal({tit:"RESERVA", msg:msg});

            //this.$emit('listado');
            this.$parent.listado();
        },

        imgUrl(){
            let url=`${this.G.url_img}?w=123654|vc_agencias|hoteles_img|||${this.reserva.hot}`;
            return url;
        },

        personas(tpp) {
            let adu=Number(tpp.charAt(0));
            let nin=Number(tpp.charAt(1));
            //let pax=adu+nin;

            let pax=String(adu)+' Adulto'+(adu>1?'s':'')+(nin>0?' '+String(nin)+' Niño':'')+(nin>1?'s':'');
            return pax;
        }

    },
}
</script>
